import { Volunteer } from "./volunteer";

export interface VolunteerSignupMentor {
	volunteerId: number,
	volunteerSignupMentorId: number,
	trimesterId: number,
	volunteerSignupMentorStatus: VolunteerSignupMentorStatusType,
	selectedLanguage: VolunteerSelectedLanguageType,
	assignedLanguageId: number | undefined,
	numMeetings: number | undefined,
	createdUTC: number,
	updatedUTC: number,
	lastContactUTC?: number,
	lastContactStaffId?: number,
	assignedToStaffId?: number,
	person: {
		id: number,
		fullName: string
	}
}

export interface VolunteerMentorPool extends Volunteer {
	volunteerSignupMentorStatus: {
		selectedTrimester: MentorTrimesterAvailability,
		selectedNextTrimester: MentorTrimesterAvailability
	}
}

export interface MentorTrimesterAvailability {
	status: VolunteerSignupMentorStatusType | undefined,
	selectedLanguage: VolunteerSelectedLanguageType | undefined,
	assignedLanguageId: number | undefined;
}

export enum VolunteerSignupMentorStatusEnum {
	Pending = 'Pending',
	Assigned = 'Assigned',
	Rejected = 'Rejected',
	Backup = 'Backup'
}

export type VolunteerSignupMentorStatusType = `${VolunteerSignupMentorStatusEnum}`;

export enum VolunteerSelectedLanguageEnum {
	EN = 'EN',
	ES = 'ES',
	BOTH = 'both'
}
export type VolunteerSelectedLanguageType = `${VolunteerSelectedLanguageEnum}`;